import MainPage from 'components/pagesComponents/main';

export default MainPage;
